import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons/';
import SystemNavigation from 'src/web/components/SystemNavigation/index';
import { useStyles } from './styles';

export default function NotFoundPage() {
  const classes = useStyles();

  return (
    <>
      <Box bgcolor="warning.light" className={classes.icon_box}>
        <HelpOutline className={classes.icon_box_icon} />
      </Box>
      <Box>
        <Typography variant="h3">404</Typography>
      </Box>
      <Box>
        <Typography variant="subtitle1">
          We’re sorry. The resource you are looking for cannot be found. Please
          choose an option below.
        </Typography>
      </Box>
      <SystemNavigation />
    </>
  );
}
